"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pet = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Pet = function Pet(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.092 1.012c.94-.132 1.936.87 2.223 2.253.287 1.376-.231 2.604-1.171 2.744-.933.14-1.936-.863-2.231-2.246-.295-1.376.239-2.604 1.179-2.751zm5.697 0c.948.147 1.474 1.375 1.195 2.75-.303 1.384-1.299 2.386-2.24 2.247-.947-.14-1.465-1.368-1.17-2.744C8.86 1.882 9.856.88 10.789 1.012zM.829 4.586c.909-.38 2.144.311 2.789 1.516C4.223 7.33 4.016 8.62 3.116 9c-.9.381-2.127-.303-2.757-1.523-.63-1.22-.406-2.518.47-2.89zm14.342 0c.876.373 1.1 1.671.47 2.891-.63 1.22-1.857 1.904-2.757 1.523-.9-.38-1.107-1.67-.502-2.898.645-1.205 1.88-1.896 2.789-1.516zm-1.33 8.378c.031.73-.543 1.538-1.228 1.841-1.426.638-3.115-.683-4.7-.683-1.586 0-3.291 1.375-4.693.684-.797-.381-1.347-1.391-1.243-2.23.143-1.159 1.57-1.78 2.414-2.627 1.123-1.096 1.92-3.156 3.521-3.156 1.594 0 2.438 2.029 3.514 3.156.884.948 2.358 1.748 2.414 3.015z",
    fill: "currentColor"
  }));
};

exports.Pet = Pet;
var _default = Pet;
exports.default = _default;